export default __webpack_public_path__ + "static/media/chat-face1.bd004aed.png";